var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 17.7579C24 19.8117 22.3276 21.4841 20.2738 21.4841H0V6.72619C0 4.67241 1.67241 3 3.72619 3H24V17.7579Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3984 13.973H18.9388C18.9828 13.973 19.0855 13.9584 19.1295 13.9584C19.423 13.8997 19.6723 13.6356 19.6723 13.2689C19.6723 12.9168 19.423 12.6527 19.1295 12.5794C19.0855 12.5647 18.9975 12.5647 18.9388 12.5647H17.3985L17.3984 13.973Z",
    fill: "url(#paint0_linear_304_292)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7627 4.24683C17.2957 4.24683 16.0927 5.4352 16.0927 6.91683V9.68948H19.863C19.951 9.68948 20.0537 9.68948 20.127 9.70411C20.9779 9.74817 21.6087 10.1882 21.6087 10.951C21.6087 11.5525 21.1833 12.066 20.3911 12.1687V12.198C21.2566 12.2566 21.9168 12.7408 21.9168 13.4889C21.9168 14.2958 21.1833 14.8239 20.215 14.8239H16.0781V20.2518H19.995C21.462 20.2518 22.665 19.0635 22.665 17.5818V4.24683H18.7627Z",
    fill: "url(#paint1_linear_304_292)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4816 11.1273C19.4816 10.7751 19.2322 10.5404 18.9388 10.4963C18.9095 10.4963 18.8361 10.4817 18.7921 10.4817H17.3984V11.7726H18.7921C18.8362 11.7726 18.9241 11.7726 18.9388 11.758C19.2323 11.7139 19.4817 11.4793 19.4817 11.1272",
    fill: "url(#paint2_linear_304_292)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00494 4.24683C2.53794 4.24683 1.33494 5.4352 1.33494 6.91683V13.5037C2.08316 13.8704 2.86062 14.1051 3.63819 14.1051C4.56237 14.1051 5.06113 13.5477 5.06113 12.7848V9.67476H7.34966V12.7701C7.34966 13.973 6.60153 14.956 4.06363 14.956C2.52331 14.956 1.32031 14.6185 1.32031 14.6185V20.2371H5.23719C6.70419 20.2371 7.90719 19.0488 7.90719 17.5671V4.24701L4.00494 4.24683Z",
    fill: "url(#paint3_linear_304_292)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3839 4.24683C9.91687 4.24683 8.71387 5.4352 8.71387 6.91683V10.4083C9.38877 9.83611 10.5623 9.46936 12.4548 9.55739C13.467 9.60145 14.5525 9.88017 14.5525 9.88017V11.0098C14.0097 10.731 13.3643 10.4816 12.5281 10.4229C11.0904 10.3202 10.2249 11.0244 10.2249 12.2566C10.2249 13.5036 11.0904 14.2078 12.5281 14.0904C13.3643 14.0317 14.0098 13.7677 14.5525 13.5036V14.6332C14.5525 14.6332 13.4816 14.9119 12.4548 14.956C10.5623 15.0439 9.38877 14.6772 8.71396 14.1051V20.2665H12.6308C14.0978 20.2665 15.3007 19.0782 15.3007 17.5965V4.24701L11.3839 4.24683Z",
    fill: "url(#paint4_linear_304_292)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_304_292",
    x1: -113.413,
    y1: 83.1549,
    x2: 545.834,
    y2: 83.1549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_304_292",
    x1: 17.2835,
    y1: 803.857,
    x2: 676.564,
    y2: 803.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_304_292",
    x1: -113.432,
    y1: 74.8452,
    x2: 545.85,
    y2: 74.8452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_304_292",
    x1: 2.4796,
    y1: 803.857,
    x2: 671.917,
    y2: 803.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_304_292",
    x1: 4.91983,
    y1: 803.85,
    x2: 655.104,
    y2: 803.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1735,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5731,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.d8bc01a0ced923c4f96e49312c9dc308.svg";
export { ForwardRef as ReactComponent };